import { useSearchParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { WinsPanel } from "./WinsPanel";
import { TrendsPanel } from "./TrendsPanel";

type InsightsTab = "wins" | "trends";
const validTabs = new Set<InsightsTab>(["wins", "trends"]);

export function InsightsView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab") as InsightsTab | null;
  const tab: InsightsTab = requestedTab && validTabs.has(requestedTab) ? requestedTab : "wins";

  const setTab = (nextTab: InsightsTab) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", nextTab);
    setSearchParams(next);
  };

  return (
    <div className="space-y-8">
      {/* Sub-navigation */}
      <div className="flex gap-6 border-b border-slate-200">
        <TabButton
          active={tab === "wins"}
          onClick={() => setTab("wins")}
          label="Win Rates"
        />
        <TabButton
          active={tab === "trends"}
          onClick={() => setTab("trends")}
          label="Score Trends"
        />
      </div>

      {tab === "wins" && <WinsPanel />}
      {tab === "trends" && <TrendsPanel />}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  label,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "pb-3 border-b-2 text-[13px] font-medium transition-colors cursor-pointer",
        active
          ? "border-brand-600 text-brand-600"
          : "border-transparent text-slate-400 hover:text-slate-600"
      )}
    >
      {label}
    </button>
  );
}
